import styled from '@emotion/styled'

import { Color } from '../../../../constants'

export const Row = styled.tr({
  borderBottom: `1px solid ${Color.GREY}`,
})
